import { isNumber } from 'lodash';

export const nameRules = [
  {
    required: true,
    message: 'Party Name is mandatory'
  },
  {
    pattern: /[a-zA-Z0-9]+/,
    message: "Party Name can't have only space/special characters"
  }
];

export const partyKeyRules = [
  {
    pattern: /^[a-zA-Z0-9]/,
    message: "Party ID can't start with space/special characters"
  }
];

export const aliasRules = [
  {
    pattern: /^[a-zA-Z0-9]/,
    message: "Party Alias can't start with space/special characters"
  }
];

export const countryRules = [
  {
    pattern: /^[a-zA-Z0-9]/,
    message: "Country can't start with space/special characters"
  }
];

export const nationalityRules = [
  {
    pattern: /^[a-zA-Z0-9]/,
    message: "Nationality can't start with space/special characters"
  }
];

export const cityRules = [
  {
    pattern: /^[a-zA-Z0-9]/,
    message: "City can't start with space/special characters"
  }
];

export const zipRules = [
  {
    pattern: /^[^a-zA-Z]*$/,
    message: "Zip/Postal Code can't have alphabets"
  },
  {
    pattern: /^[a-zA-Z0-9]/,
    message: "Zip/Postal Code can't start with space/special characters"
  }
];

export const addressRules = [
  {
    pattern: /[a-zA-Z0-9]+/,
    message: "Address can't have only space/special characters"
  }
];

export const prepareAlertHistoryFilters = (filters, jobId) => {
  const result = [];
  const { alertLevel } = filters;

  if (alertLevel) {
    result.push({
      columnName: 'alertLevel',
      logic: 'like',
      value: alertLevel
    });
  }

  if (jobId) {
    result.push({
      columnName: 'runInstanceExecutionId',
      logic: 'LIKE',
      value: jobId
    });
  }

  return result;
};
